import { Skeleton } from 'antd';
import { Column, Row } from 'farmhub-ui-core';
import styled from 'styled-components';

import { theme } from 'styled';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  border-bottom: 1px solid ${props => props.theme.colors.border.main};

  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: ${props => props.theme.app.padding.vertical};
`;

const InfoCard = styled.div`
  display: flex;
  width: fit-content;
`;

const Img = styled.div`
  width: 64px;
  height: 42px;
  box-sizing: border-box;
  border-radius: 50%;
`;

const EntityCardSkeletonMobile = () => (
  <Wrapper>
    <Row justifyContent="space-between">
      <InfoCard>
        <Img>
          <Skeleton.Avatar size="large" />
        </Img>
        <Column styles={{ gap: theme.spacing.xxs }}>
          <Skeleton.Input size="small" style={{ width: 200 }} />
          <Skeleton.Input size="small" style={{ width: 200 }} />
        </Column>
      </InfoCard>
      <Row width="fit-content">
        <Skeleton.Input
          size="small"
          style={{ width: 20, height: 20, borderRadius: '50%' }}
        />
      </Row>
    </Row>
  </Wrapper>
);

export default EntityCardSkeletonMobile;
